export { default as SmashPath } from './smashPath';

export const capitalizeFirstLetter = (string: string) => {
  if (string) {
    string = string.charAt(0).toUpperCase() + string.slice(1);
  }
  return string;
};

export const getCompleteAddress = (data) => {
  if (!data) return '';

  let addressUparsedParts: string[] = [];
  let addressParts: string[] = [];

  if (data.StreetNumber) {
    addressUparsedParts.push(data.StreetNumber);
  }

  if (data.StreetDirPrefix) {
    addressUparsedParts.push(data.StreetDirPrefix);
  }

  if (data.StreetName) {
    addressUparsedParts.push(data.StreetName);
  }

  if (data.StreetSuffix && !data.StreetName?.includes(data.StreetSuffix)) {
    addressUparsedParts.push(data.StreetSuffix);
  }
  if (addressUparsedParts.length > 0) {
    addressParts.push(addressUparsedParts.join(' '));
  }

  if (data.UnitNumber) {
    addressParts.push(data.UnitNumber);
  }

  if (data.City) {
    addressParts.push(data.City);
  }

  if (data.StateOrProvince) {
    addressParts.push(data.StateOrProvince);
  }

  if (data.PostalCode) {
    addressParts.push(data.PostalCode);
  }

  if (data.Country) {
    addressParts.push(data.Country);
  }

  return addressParts.join(', ');
};

export const getCompiledAddress = (data: any): string => {
  let addressParts: string[] = [];

  if (data.UnparsedAddress) {
    addressParts.push(data.UnparsedAddress);
  } else if (data.UnitNumber) {
    addressParts.push(data.UnitNumber);
  }

  if (data.City) {
    addressParts.push(data.City);
  }

  if (data.StateOrProvince) {
    addressParts.push(data.StateOrProvince);
  }

  if (data.PostalCode) {
    addressParts.push(data.PostalCode);
  }

  if (data.Country) {
    addressParts.push(data.Country);
  }

  return addressParts.join(', ');
};

const measurement = (data) => {
  if (
    data.resoProperty.LotSizeUnits === 'Square Feet' ||
    data.resoProperty.BuildingAreaUnits === 'Square Feet'
  ) {
    return 'sq.ft';
  } else if (
    data.resoProperty.LotSizeUnits === 'Square Meters' ||
    data.resoProperty.BuildignAreaUnits === 'Square Meters'
  ) {
    return 'm²';
  } else {
    return '';
  }
};

const unitsShown = (data) => {
  if (data.resoProperty.BedroomsTotal && data.resoProperty.BathroomsTotalInteger) {
    return (
      `${data.resoProperty.BedroomsTotal} beds, ${data.resoProperty.BathroomsTotalInteger} baths` +
      ' '
    );
  } else if (
    data.resoProperty.BuildingAreaTotal &&
    (data.resoProperty.LotSizeUnits || data.resoProperty.BuildingAreaUnits)
  ) {
    return `${data.resoProperty.BuildingAreaTotal} ${measurement(data)}` + ' ';
  } else {
    return '';
  }
};

export const getPropertyMetaDetails = (data) => {
  if (!data) return { title: '', description: '' };

  const forSaleOrRent = data.resoProperty.PropertyType.includes('Lease') ? 'Rent' : 'Sale';

  const firstSentenceOfPublicRemarks =
    // Splits out first sentence at exclamation marks or periods that aren't decimals or "sq.ft."
    data.resoProperty.PublicRemarks?.split(/(?<!\d\.)\s*(?<!sq)(?<!ft)\.|\!|\?/)[0] || '';

  const propertyType =
    data.resoProperty.PropertyType === 'Land'
      ? data.resoProperty.PropertyType
      : data.resoProperty.PropertySubType || data.resoProperty.PropertyType;

  return {
    title: `${getCompiledAddress(data.resoProperty)} | ${propertyType} For ${forSaleOrRent}`,
    description: `${firstSentenceOfPublicRemarks}${unitsShown(
      data,
    )} ${propertyType} for ${forSaleOrRent.toLowerCase()} in ${data.resoProperty.City}, ${
      data.resoProperty.StateOrProvince ? data.resoProperty.StateOrProvince + ', ' : ''
    }${data.resoProperty.Country}.`,
  };
};

export const getCompiledAddressForDevelopments = (data) => {
  if (!data) return '';

  let addressUparsedParts: string[] = [];
  let addressParts: string[] = [];

  if (data.StreetNumber) {
    addressUparsedParts.push(data.StreetNumber);
  }

  if (data.StreetDirPrefix) {
    addressUparsedParts.push(data.StreetDirPrefix);
  }

  if (data.StreetName) {
    addressUparsedParts.push(data.StreetName);
  }

  if (data.StreetSuffix && !data.StreetName?.includes(data.StreetSuffix)) {
    addressUparsedParts.push(data.StreetSuffix);
  }
  if (addressUparsedParts.length > 0) {
    addressParts.push(addressUparsedParts.join(' '));
  }

  if (data.UnitNumber) {
    addressParts.push(data.UnitNumber);
  }

  return addressParts.join(', ');
};
